import { Injectable } from '@angular/core';
import { from, Observable } from 'rxjs';
import { IndexedDbService } from '../../services/indexed-db.service';
import { PickerRecentRecord } from '../components/entity-dropdown-picker/picker-recent.model';

@Injectable({
  providedIn: 'root',
})
export class PickerRecentCacheService {
  constructor(private indexedDbService: IndexedDbService) {}

  loadRecent<T>(entityKey: string, limit = 10): Observable<T[]> {
    return from(this.loadRecentAsync<T>(entityKey, limit));
  }

  remember<T>(record: PickerRecentRecord<T>): Observable<void> {
    return from(this.indexedDbService.cachePickerRecent(record));
  }

  private async loadRecentAsync<T>(entityKey: string, limit = 10): Promise<T[]> {
    const records = await this.indexedDbService.getPickerRecentRecords(entityKey, this.getCurrentUserKey());
    return records
      .sort((a, b) => b.lastUsedAt - a.lastUsedAt)
      .slice(0, limit)
      .map((record) => record.payload as T);
  }

  private getCurrentUserKey(): string {
    try {
      const rawUser = sessionStorage.getItem('appUser');
      if (!rawUser) {
        return 'anonymous';
      }

      const parsed = JSON.parse(rawUser);
      return String(parsed?.id ?? 'anonymous');
    } catch {
      return 'anonymous';
    }
  }
}

